import React from 'react';
import { useLocalization } from '@/Hooks';
import styles from './SingleDocumentPrintModal.scss';
import { Modal } from '@/Components/Modal/Modal';
import { FormInput } from '@/Components/Controls/Input/FormInput';
import { ButtonsWrapper } from '@/Components/Forms/ButtonsSection/ButtonsSection';
import { Button } from '@/Components/Controls/Button/Button';
import { BUTTON_THEMES } from '@/Components/Controls/Button/ButtonThemes';
import { useSingleDocumentPrintModal } from './hooks/useSingleDocumentPrintModal';

type Props = {
  onClose: () => void;
};

export const SingleDocumentPrintModal = ({ onClose }: Props) => {
  const {
    modalWindows: {
      documentPrintModal: { SingleDocumentPrintModal },
    },
    buttons: { Cancel, Ok },
  } = useLocalization();

  const { onPrintSingleDocument, onCountCopyChanged } = useSingleDocumentPrintModal(onClose);

  return (
    <Modal
      onClose={onClose}
      description={{
        title: SingleDocumentPrintModal.Title,
      }}
    >
      <div className={styles.modalWrapper}>
        <div className={styles.modalInfo}>
          <p>{SingleDocumentPrintModal.Text}</p>

          <FormInput
            min={1}
            max={10}
            valueForSet={1}
            type={'number'}
            name={'countCopy'}
            className={styles.copyCount}
            onChange={onCountCopyChanged}
          />
        </div>

        <ButtonsWrapper>
          <Button text={Cancel} theme={BUTTON_THEMES.SUCCESS_TRANSPARENT} onClick={onClose} />
          <Button text={Ok} autoFocus={true} theme={BUTTON_THEMES.SUCCESS} onClick={onPrintSingleDocument} />
        </ButtonsWrapper>
      </div>
    </Modal>
  );
};
